import React, { useState, useEffect, useRef, useCallback } from "react";

import { Editor } from "@tinymce/tinymce-react";

import { useParams, useHistory } from "react-router";

import LoadingData from "../../Common/LoadingData";

const AddStory = () => {
  const [allNameQuiz, setAllNameQuiz] = useState([]);
  const [selectQuiz, setSelectQuiz] = useState([]);
  const [pending, setPending] = useState(false);
  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(false);
  const [storyData, setStoryData] = useState({
    title: "",
    description: "",
    quizzes: [],
    level: "",
    membership: "",
  });

  const { id } = useParams();
  const history = useHistory();

  const editorRef = useRef("");

  const handleRemoveQuiz = (name, id) => {
    setSelectQuiz([...selectQuiz.filter((quiz) => quiz._id !== id)]);
    setStoryData({
      ...storyData,
      quizzes: storyData.quizzes.filter((qui) => qui !== id),
    });
  };

  const handleChange = (e) => {
    e.preventDefault();

    setPending(true);

    const dataStory = {
      ...storyData,
      description: editorRef.current.getContent(),
    };

    if (storyData.quizzes.length === 0) {
      setPending(false);
      alert("Please select at least one quiz");
    } else if (storyData.level === "") {
      setPending(false);
      alert("Please select a level");
    } else {
      if (edit) {
        fetch(`${process.env.REACT_APP_BASE_URL}/admin/read/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataStory),
          credentials: "include",
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === "success") {
              setStoryData({
                title: "",
                description: "",
                quizzes: [],
                level: "",
                membership: "",
              });
              editorRef.current = "";
              setSelectQuiz([]);
              setPending(false);
              setEdit(false);
              setTimeout(() => {
                history.push("/dashboard/all-stories");
              }, 1000);
            }
          })
          .catch((err) => {
            console.log(err);
            setPending(false);
          });
      } else {
        setEdit(false);
        fetch(`${process.env.REACT_APP_BASE_URL}/admin/read`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataStory),
          credentials: "include",
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === "success") {
              setStoryData({
                title: "",
                description: "",
                quizzes: [],
                level: "",
                membership: "",
              });
              editorRef.current = "";
              setSelectQuiz([]);
              setPending(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setPending(false);
          });
      }
    }
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/quizzes`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => {
        setAllNameQuiz([...data.msg]);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });

    setLoading(true);

    if (id) {
      // edit Story
      setEdit(true);
      fetch(`${process.env.REACT_APP_BASE_URL}/read/${id}`, {
        method: "GET",
        credentials: "include",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === "success") {
            setLoading(false);
            setStoryData({
              ...storyData,
              title: data.msg.title,
              description: "",
              level: data.msg.level,
              membership: data.msg.membership,
              quizzes: data.msg.quizzes.map((item) => {
                return item._id;
              }),
            });
            editorRef.current = data.msg.description;

            setSelectQuiz(
              data.msg.quizzes.map((item) => {
                return {
                  quiz_name: item.name,
                  _id: item._id,
                };
              })
            );
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setStoryData({
        title: "",
        description: "",
        quizzes: [],
        level: "",
        membership: "",
      });
      setSelectQuiz([]);
      editorRef.current = "";
    }
  }, [id]);

  const handelSetIdQuiz = useCallback(
    (quiz) => {
      allNameQuiz.map((item) => {
        if (item.name === quiz) {
          setStoryData({
            ...storyData,
            quizzes: [...storyData.quizzes, item._id],
          });
          setSelectQuiz([
            ...selectQuiz,
            { quiz_name: item.name, _id: item._id },
          ]);
        }
      });
    },
    [allNameQuiz, storyData]
  );

  const handleChangeQuiz = (e) => {
    if (e.target.value !== "") {
      setSelectQuiz([
        ...selectQuiz,
        {
          quiz_name: e.target.value,
        },
      ]);
      handelSetIdQuiz(e.target.value);
    }
  };

  if (loading) {
    return (
      <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
        <div className="lds-dual-ring"></div>
      </div>
    );
  }

  return (
    <section className="section-add-story mt-4 mb-5">
      <div className="container">
        <div className="row">
          <div className="col-md-10 m-auto">
            <h2>Add Story</h2>
            <div>
              <form className="form-add-story" onSubmit={handleChange}>
                <div className="form-group mt-3">
                  <label className="mb-2">Story Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Story Name"
                    value={storyData.title}
                    onChange={(e) =>
                      setStoryData({
                        ...storyData,
                        title: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="form-group mt-3">
                  <label className="mb-2">Story Description</label>
                  <div className="editor-container" style={{ width: "100%" }}>
                    <Editor
                      apiKey="htz0nznb6uk7q94cexoedjrudzji4w89jbd8f38lqopfmn6g"
                      onInit={(evt, editor) => (editorRef.current = editor)}
                      initialValue={editorRef.current}
                      init={{
                        height: 300,
                        menubar: false,
                        plugins:
                          "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons",
                        editimage_cors_hosts: ["picsum.photos"],
                        menubar:
                          "file edit view insert format tools table help",
                        toolbar:
                          "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",
                        toolbar_sticky: true,
                        autosave_ask_before_unload: true,
                        autosave_interval: "30s",
                        autosave_prefix: "{path}{query}-{id}-",
                        autosave_restore_when_empty: false,
                        autosave_retention: "2m",
                        image_advtab: true,
                        link_list: [
                          {
                            title: "My page 1",
                            value: "https://www.tiny.cloud",
                          },
                          {
                            title: "My page 2",
                            value: "http://www.moxiecode.com",
                          },
                        ],
                        image_list: [
                          {
                            title: "My page 1",
                            value: "https://www.tiny.cloud",
                          },
                          {
                            title: "My page 2",
                            value: "http://www.moxiecode.com",
                          },
                        ],
                        image_class_list: [
                          { title: "None", value: "" },
                          { title: "Some class", value: "class-name" },
                        ],
                        importcss_append: true,
                        file_picker_callback: (callback, value, meta) => {
                          /* Provide file and text for the link dialog */
                          if (meta.filetype === "file") {
                            callback(
                              "https://www.google.com/logos/google.jpg",
                              { text: "My text" }
                            );
                          }

                          /* Provide image and alt text for the image dialog */
                          if (meta.filetype === "image") {
                            callback(
                              "https://www.google.com/logos/google.jpg",
                              { alt: "My alt text" }
                            );
                          }

                          /* Provide alternative source and posted for the media dialog */
                          if (meta.filetype === "media") {
                            callback("movie.mp4", {
                              source2: "alt.ogg",
                              poster: "https://www.google.com/logos/google.jpg",
                            });
                          }
                        },
                        templates: [
                          {
                            title: "New Table",
                            description: "creates a new table",
                            content:
                              '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
                          },
                          {
                            title: "Starting my story",
                            description: "A cure for writers block",
                            content: "Once upon a time...",
                          },
                          {
                            title: "New list with dates",
                            description: "New List with dates",
                            content:
                              '<div class="mceTmpl"><span class="cdate">cdate</span><br><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
                          },
                        ],
                        template_cdate_format:
                          "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
                        template_mdate_format:
                          "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
                        height: 600,
                        image_caption: true,
                        quickbars_selection_toolbar:
                          "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
                        noneditable_class: "mceNonEditable",
                        toolbar_mode: "sliding",
                        contextmenu: "link image table",

                        content_style:
                          'body { font-family: "Montserrat"; font-size:14px }',
                      }}
                    />
                  </div>
                </div>
                <div className="form-group mt-3">
                  <label className="mb-2">Select quiz Name</label>
                  <select
                    className="form-select"
                    onChange={(e) => handleChangeQuiz(e)}
                  >
                    <option></option>
                    {allNameQuiz.map((item) => (
                      <option key={item._id} value={item.name}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="quiz-group">
                  {selectQuiz.map((item, index) => (
                    <div
                      key={index}
                      className="item-quiz_name"
                      aria-label="quiz name"
                      role="button"
                      onClick={() => handleRemoveQuiz(item.quiz_name, item._id)}
                    >
                      <span className="mb-2">{item.quiz_name}</span>
                    </div>
                  ))}
                </div>
                <div className="form-group">
                  <label className="mb-2">Story Level</label>
                  <select
                    className="form-select"
                    onChange={(e) => {
                      if (e.target.value !== "") {
                        setStoryData({
                          ...storyData,
                          level: e.target.value,
                        });
                      }
                    }}
                    value={storyData.level}
                  >
                    <option value=""></option>
                    <option value="A1">A1</option>
                    <option value="A2">A2</option>
                    <option value="B1">B1</option>
                    <option value="B2">B2</option>
                    <option value="C1">C1</option>
                    <option value="C2">C2</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="mb-2">Membership</label>
                  <select
                    className="form-select"
                    onChange={(e) => {
                      if (e.target.value !== "") {
                        setStoryData({
                          ...storyData,
                          membership: e.target.value,
                        });
                      }
                    }}
                    value={storyData.membership}
                  >
                    <option value=""></option>
                    <option value="premiumPlan">Premium</option>
                    <option value="freePlan">Free</option>
                  </select>
                </div>
                <div>
                  <button
                    className="contButSmall"
                    type="submit"
                    aria-label="save"
                    data-toggle="tooltip"
                    title="save"
                    // disabled={pending}
                  >
                    {pending ? (
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    ) : (
                      <span>save</span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AddStory;
